import React from "react";
import 'moment-timezone';
import "./Volvia.css";
import { useStore } from "../../Store";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import TimeDisplay from "./TimeDisplay";

const EventsComponentVolvia = () => {
  const { casesStore } = useStore();
  const { t } = useTranslation();

  const caseEvents: JSX.Element[] = [];
  const caseEventsETA: JSX.Element[] = [];
  const caseEvents2: JSX.Element[] = [];
  const caseEvents2ETA: JSX.Element[] = [];

  if (casesStore.events != null) {
    casesStore.events.forEach((item) => {
      if (item.eventType === 1) {
        caseEvents.push(
          <li key={"eventContainer" + item.eventType} className="status-container-event-volvia">
            <div className="status-container-event-volvia-1 ">
              <div>{t(`statuscontainerevent${item.eventType}`)}</div>
              <TimeDisplay dateTime={item.eventDateTime} classNameType="status-container-event-volvia-time"/>
            </div>
          </li>
        )
        caseEventsETA.push(
          <div key="statusContainerHeader1" className="status-container-event-volvia-header">
            {t("statuseventcontainerheader")}
          </div>
        )
      } else {
        caseEvents2.push( 
          <li key={"eventContainer" + item.eventType} className="status-container-event-volvia">
            <div className="status-container-event-volvia-1">{t(`statuscontainerevent${item.eventType}`)}
              <TimeDisplay dateTime={item.eventDateTime} classNameType="status-container-event-volvia-time"/>
            </div>
          </li>
        )
        if (caseEvents2ETA.length === 0) {
          caseEvents2ETA.push(
            <div key="statusContainerHeader2" className="status-container-event-volvia-header">
              {t("statuscontainer1")}
            </div>
          )
        } else {
          caseEvents2ETA.fill(
            <div key="statusContainerHeader2" className="status-container-event-volvia-header">
              {t("statuscontainer1")}
            </div>
          )
        }
      }
    });

    return (
      <div id="status-container-polestar">
        {(() => {
          return (
            <div>
              {caseEvents2ETA}
              <ul className="volvia-events-list">
                {caseEvents2.reverse()}
              </ul>
              {caseEventsETA}
              <ul className="volvia-events-list">
                {caseEvents.reverse()}
              </ul>
            </div>
          )
        })()}
      </div>
    );
  }

  return <div className="loading-bar"></div>;
}

export default observer(EventsComponentVolvia);